import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/no_image.png'
import _imports_1 from '@/assets/icons/bed-icon.png'
import _imports_2 from '@/assets/icons/bath-icon.png'
import _imports_3 from '@/assets/icons/guest-icon.png'
import _imports_4 from '@/assets/icons/pet-icon.png'
import _imports_5 from '@/assets/icons/nopet-icon.png'


const _withScopeId = n => (_pushScopeId("data-v-6e9c8fdb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "search/filter",
  style: {"padding-left":"20px","padding-right":"10px","padding-top":"5px"}
}
const _hoisted_2 = {
  class: "ldx-property-list",
  style: {"padding":"20px"}
}
const _hoisted_3 = { slot: "end" }
const _hoisted_4 = {
  key: 0,
  slot: "end"
}
const _hoisted_5 = {
  key: 1,
  slot: "end"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding-bottom":"100px"} }, null, -1))
const _hoisted_8 = {
  key: 0,
  style: {"font-weight":"700","font-size":"15px","margin":"0px","color":"black"}
}
const _hoisted_9 = { style: {"font-weight":"400"} }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = { style: {"font-weight":"400"} }
const _hoisted_12 = {
  class: "ldx-property-list",
  style: {"padding":"15px","max-width":"500px"}
}
const _hoisted_13 = {
  hidden: "",
  style: {"font-weight":"700","font-size":"medium","font-family":"'Montserrat', sans-serif"}
}
const _hoisted_14 = {
  key: 1,
  src: _imports_0
}
const _hoisted_15 = {
  class: "ldx-prop-price",
  style: {"width":"100px","text-align":"center"}
}
const _hoisted_16 = { class: "ldx-quick-amenities" }
const _hoisted_17 = { class: "ldx-quick-amenity" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_19 = { class: "ldx-quick-amenity" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_21 = { class: "ldx-quick-amenity" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_23 = { class: "ldx-quick-amenity" }
const _hoisted_24 = {
  key: 0,
  src: _imports_4
}
const _hoisted_25 = {
  key: 1,
  src: _imports_5
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Select Property ", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Property Selected ", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding":"75px"} }, null, -1))
const _hoisted_29 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_card = _resolveComponent("ion-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isMinimal)
      ? (_openBlock(), _createBlock(_component_ion_header, { key: 0 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_ion_item, {
                lines: "none",
                class: "ion-no-padding"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_searchbar, {
                    style: {"padding-left":"0px","padding-right":"0px"},
                    debounce: 0,
                    onIonInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.searchChange($event)))
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.isMinimal)
      ? (_openBlock(), _createBlock(_component_ion_content, {
          key: 1,
          style: {"--background":"white"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availablePropertyList, (item, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                  (_ctx.searchPropertyMatch(index, item))
                    ? (_openBlock(), _createBlock(_component_ion_list, {
                        key: index,
                        value: item,
                        lines: "none",
                        class: "ldx-reservation-form"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, {
                                onClick: ($event: any) => (_ctx.selectProperty(index, item))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item['name']), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createElementVNode("div", _hoisted_3, [
                                (!_ctx.isSelectedProperty(index, item))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                      _createVNode(_component_ion_icon, { icon: _ctx.closeCircleOutline }, null, 8, ["icon"])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.isSelectedProperty(index, item))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                      _createVNode(_component_ion_icon, {
                                        color: "success",
                                        icon: _ctx.checkmarkCircleOutline
                                      }, null, 8, ["icon"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", {
                                style: {"padding-top":"4px","margin-right":"0px","margin-left":"10px"},
                                slot: "end",
                                onClick: ($event: any) => (_ctx.getInfo(index, item))
                              }, [
                                _createVNode(_component_ion_icon, {
                                  size: "large",
                                  icon: _ctx.informationCircleOutline
                                }, null, 8, ["icon"])
                              ], 8, _hoisted_6)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 256)),
              _hoisted_7
            ]),
            _createVNode(_component_ion_grid, {
              class: "ldx-bottom-fixed",
              style: {"padding":"0px","margin":"0px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_row, { style: {"padding":"0px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, { style: {"padding":"0px"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_button, {
                          style: {"width":"100%","height":"100%","margin":"0px"},
                          expand: "full",
                          color: "danger",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cancel()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Cancel")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_col, { style: {"padding":"0px"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_button, {
                          style: {"width":"100%","height":"100%","margin":"0px"},
                          expand: "full",
                          fill: "solid",
                          color: "primary",
                          onClick: _ctx.confirm
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Continue")
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!_ctx.isMinimal)
      ? (_openBlock(), _createBlock(_component_ion_header, { key: 2 }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_toolbar, {
              color: "primary",
              mode: "md"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_title, { style: {"font-family":"'Montserrat', sans-serif","font-weight":"700","text-align":"center"} }, {
                  default: _withCtx(() => [
                    _createTextVNode("Select Property")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_item, {
              lines: "none",
              style: {"--background":"white","border-bottom":"1px","border-bottom-style":"solid","border-bottom-color":"var(--ion-color-medium)"}
            }, {
              default: _withCtx(() => [
                (!_ctx.isSearchOpen)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                      _createTextVNode(" Available: "),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.availablePropertyList.length) + " Properties", 1),
                      _hoisted_10,
                      _createTextVNode(" Dates: "),
                      _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.formatDate(_ctx.store.reservationStartDate)) + " - " + _toDisplayString(_ctx.formatDate(_ctx.store.reservationEndDate)), 1)
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.isSearchOpen)
                  ? (_openBlock(), _createBlock(_component_ion_icon, {
                      key: 1,
                      style: {"color":"black","position":"relative","margin-right":"0px","height":"30px","width":"30px","cursor":"pointer"},
                      slot: "end",
                      src: _ctx.searchCircle,
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchButton()))
                    }, null, 8, ["src"]))
                  : _createCommentVNode("", true),
                (_ctx.isSearchOpen)
                  ? (_openBlock(), _createBlock(_component_ion_icon, {
                      key: 2,
                      style: {"color":"black","position":"relative","margin-right":"0px","height":"30px","width":"30px","cursor":"pointer"},
                      slot: "end",
                      src: _ctx.closeCircle,
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchButton()))
                    }, null, 8, ["src"]))
                  : _createCommentVNode("", true),
                (_ctx.isSearchOpen)
                  ? (_openBlock(), _createBlock(_component_ion_searchbar, {
                      key: 3,
                      style: {"--background":"white"},
                      mode: "ios",
                      placeholder: "Property Name",
                      debounce: 0,
                      onIonInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.searchChange($event))),
                      "show-clear-button": "never"
                    }))
                  : _createCommentVNode("", true),
                (_ctx.order == 'descending')
                  ? (_openBlock(), _createBlock(_component_ion_icon, {
                      key: 4,
                      slot: "end",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeOrder())),
                      style: {"color":"black"},
                      icon: _ctx.filter
                    }, null, 8, ["icon"]))
                  : _createCommentVNode("", true),
                (_ctx.order == 'ascending')
                  ? (_openBlock(), _createBlock(_component_ion_icon, {
                      key: 5,
                      slot: "end",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeOrder())),
                      style: {"color":"black","transform":"scaleY(-1)"},
                      icon: _ctx.filter
                    }, null, 8, ["icon"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!_ctx.isMinimal)
      ? (_openBlock(), _createBlock(_component_ion_content, {
          key: 3,
          class: "ion-no-padding",
          style: {"text-align":"-webkit-center","--background":"rgb(239, 246, 255)"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("p", _hoisted_13, " Dates: " + _toDisplayString(_ctx.getDateToString(_ctx.store.reservationStartDate)) + " - " + _toDisplayString(_ctx.getDateToString(_ctx.store.reservationEndDate)), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availablePropertyList, (item, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                  (_ctx.searchPropertyMatch(index, item))
                    ? (_openBlock(), _createBlock(_component_ion_card, {
                        mode: "ios",
                        class: "ldx-property-card",
                        onClick: ($event: any) => (_ctx.selectProperty(index, item)),
                        key: index,
                        value: item,
                        style: {"cursor":"pointer"}
                      }, {
                        default: _withCtx(() => [
                          (item['thumbnail_url'] != null && item['thumbnail_url'] != '')
                            ? (_openBlock(), _createBlock(_component_ion_img, {
                                key: 0,
                                src: item['thumbnail_url']
                              }, null, 8, ["src"]))
                            : (_openBlock(), _createElementBlock("img", _hoisted_14)),
                          _createVNode(_component_ion_card_header, { style: {"text-align":"left"} }, {
                            default: _withCtx(() => [
                              (item['address']['short_name'] != null && item['address']['short_name'] != '')
                                ? (_openBlock(), _createBlock(_component_ion_card_subtitle, { key: 0 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, { icon: _ctx.locationSharp }, null, 8, ["icon"]),
                                      _createTextVNode(" " + _toDisplayString(item['address']['short_name']), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              _createVNode(_component_ion_card_title, { color: "primary" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item['name']), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_ion_card_content, null, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_15, [
                                _createElementVNode("strong", null, _toDisplayString(_ctx.getDisplayMoney(_ctx.getPropertyFees(item['id']).total)), 1),
                                _createTextVNode(" Total ")
                              ]),
                              _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("div", _hoisted_17, [
                                  _hoisted_18,
                                  _createElementVNode("span", null, _toDisplayString(item['bedrooms']), 1)
                                ]),
                                _createElementVNode("div", _hoisted_19, [
                                  _hoisted_20,
                                  _createElementVNode("span", null, _toDisplayString(item['baths']), 1)
                                ]),
                                _createElementVNode("div", _hoisted_21, [
                                  _hoisted_22,
                                  _createElementVNode("span", null, _toDisplayString(item['max_guests']), 1)
                                ]),
                                _createElementVNode("div", _hoisted_23, [
                                  (item['pets_allowed'])
                                    ? (_openBlock(), _createElementBlock("img", _hoisted_24))
                                    : (_openBlock(), _createElementBlock("img", _hoisted_25))
                                ])
                              ])
                            ]),
                            _: 2
                          }, 1024),
                          (!_ctx.isSelectedProperty(index, item))
                            ? (_openBlock(), _createBlock(_component_ion_chip, {
                                key: 2,
                                style: {"max-width":"-webkit-fill-available","max-height":"40px","height":"auto","display":"flex","justify-content":"center","align-items":"center","padding":"0px"}
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_26
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.isSelectedProperty(index, item))
                            ? (_openBlock(), _createBlock(_component_ion_chip, {
                                key: 3,
                                style: {"background":"#4c81f2","max-width":"-webkit-fill-available","max-height":"40px","height":"auto","display":"flex","justify-content":"center","align-items":"center","padding":"0px"}
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_27
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["onClick", "value"]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 256))
            ]),
            _hoisted_28,
            (!_ctx.isMinimal)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createVNode(_component_ion_grid, {
                    mode: "ios",
                    class: "ldx-bottom-fixed"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                style: {"width":"-webkit-fill-available"},
                                color: "danger",
                                onClick: _ctx.cancel
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Cancel")
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}